export const css = {
	root: 'IUFjeb5U',
	legend: '_1FCyh4RR',
	' _key': 'certwise-theme/dojo/radio-group'
};

export default css;
